import type { WorkspaceElsewhereRow } from "@elaso/shared/types/db";
import type { WorkspaceElsewhereStartResult } from "@elaso/shared/types/lti";
import { type ReactNode, useState } from "react";
import { toast } from "sonner";
import { ulid } from "ulid";
import { CrossInstanceConsentDialog } from "@/components/app/sidebar/cross-instance-consent-dialog";
import { switchInstance } from "@/lib/lti/instance-switch";
import { ws } from "@/lib/websocket-wrapper";

const enter = async (entry: WorkspaceElsewhereRow, consent: boolean) => {
	try {
		const outcome = await switchInstance(
			() =>
				ws.sendWithPromise<WorkspaceElsewhereStartResult>({
					id: ulid(),
					procedure: "workspace.startLaunchElsewhere",
					data: {
						connectionId: entry.connectionId,
						...(consent && { consent: true }),
					},
				}),
			{ connectionId: entry.connectionId, workspaceName: entry.workspaceName }
		);
		if (!outcome.ok) toast.error(outcome.message);
	} catch (error) {
		toast.error(error instanceof Error ? error.message : String(error));
	}
};

export function useEnterWorkspaceElsewhere(): {
	select: (entry: WorkspaceElsewhereRow) => void;
	consentDialog: ReactNode;
} {
	const [asking, setAsking] = useState<WorkspaceElsewhereRow | null>(null);
	return {
		select: (entry) => {
			if (entry.consentGiven) {
				enter(entry, false);
				return;
			}
			setAsking(entry);
		},
		consentDialog: (
			<CrossInstanceConsentDialog
				entry={asking}
				onAccept={(entry) => {
					setAsking(null);
					enter(entry, true);
				}}
				onDecline={() => setAsking(null)}
			/>
		),
	};
}
